import { ReactElement, PropsWithChildren } from "react";
import * as styles from "./Card.module.scss";

export function Card(props: PropsWithChildren<{}>): ReactElement {
    return <section className={styles.card}>{props.children}</section>;
}
